/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, func, shape,
    string, number, arrayOf,
} from 'prop-types';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { isEmpty } from '../../../utils/object';
import { uuidv4 } from '../../../utils/uuid';
import { cipher } from '../../../utils/crypto';
import { secureProtocol } from '../../../utils/secureProtocol';
import SubscriptionCancelDialog from '../MobileSubscriptions/SubscriptionCancelDialog';

const styles = (theme) => ({
    processed: {
        color: theme.palette.common.green,
    },
    cancelled: {
        color: theme.palette.cms.primary,
    },
    cancelLink: {
        marginLeft: 24,
    },
});

class DesktopSubscriptionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancelDialogOpen: false,
            subscriptionRuleId: '',
        };
    }

    handleCancelClick = (subscriptionRuleId) => {
        this.setState({ cancelDialogOpen: true, subscriptionRuleId });
    }

    handleCancelDialogClose = () => {
        this.setState({ cancelDialogOpen: false });
    }

    handleCancelConfirmed = () => {
        const { handleCancel } = this.props;
        const { subscriptionRuleId } = this.state;
        this.setState({ cancelDialogOpen: false });
        if (subscriptionRuleId) {
            handleCancel(subscriptionRuleId);
        }
    }

    subscriptionDuration = (d) => {
        const SUBSCRIPTION_DURATIONS = {
            '-1': 'Continue until I stop',
            3: 'Three months',
            6: 'Six months',
            12: 'Twelve months',
        };

        return SUBSCRIPTION_DURATIONS[d] ? SUBSCRIPTION_DURATIONS[d] : d;
    }

    subscriptionInterval = (i) => {
        const SUBSCRIPTION_INTERVALS = {
            1: 'Every 1 week',
            4: 'Every 4 weeks',
            6: 'Every 6 weeks',
            8: 'Every 8 weeks',
            30: 'Monthly',
        };

        return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
    }

    dateFormater = (date) => {
        if (/^\d{4}[-/]\d{2}[-/]\d{2}$/.test(date)) {
            const dateArray = date.split('-');
            return [dateArray[1], dateArray[2], dateArray[0]].join('/');
        }
        return date;
    }

    generateViewDetailsURL = (orderNumber, history) => {
        const uuid = uuidv4();
        const cipherKey = uuid.slice(0, 8);
        const cryptedOrderNumber = cipher(cipherKey)(orderNumber).replace(
            /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
            '$1-$2-$3-$4-$5',
        );
        const url = [
            '/account/orders',
            uuid,
            cryptedOrderNumber,
            '0',
        ].join('/');
        history.push(url);
    }

    statusTemplate = (classes, subscriptionRuleId, subscriptionStatus) => {
        if (subscriptionStatus === 'PROCESSED') {
            return (
                <>
                    <span className={classes.processed}>{subscriptionStatus}</span>
                    <span role="presentation" className={`link ${classes.cancelLink}`} onClick={() => this.handleCancelClick(subscriptionRuleId)}>
                        Cancel
                    </span>
                </>
            );
        }
        return (
            <>
                <span className={classes.cancelled}>{subscriptionStatus}</span>
            </>
        );
    }

    render() {
        const { classes, subscription, history } = this.props;
        const { cancelDialogOpen } = this.state;
        if (isEmpty(subscription)) return null;
        const productImageThumbnail = subscription.productImageThumbnail ? secureProtocol(subscription.productImageThumbnail) : subscription.productImageThumbnail;
        return (
            <>
                <Grid container>
                    <Grid className="productInfoWrapper" item xs={4}>
                        <img alt={subscription.productName} src={productImageThumbnail} />
                        <div className="productInfo">
                            <div>{subscription.productName}</div>
                            <div>Item #: {subscription.productId}</div>
                            <div>Price: ${subscription.price}</div>
                            <div>Qty: {subscription.quantity}</div>
                        </div>
                    </Grid>
                    <Grid className="orderHistoryWrapper" item xs={8}>
                        <div className="historyTitle">Order History</div>
                        <div className="orderHistoryTable">
                            <Grid className="tableHead" container>
                                <Grid item xs={3}>Order #</Grid>
                                <Grid item xs={3}>Order Date</Grid>
                                <Grid item xs={3}>Delivery Date</Grid>
                                <Grid item xs={3} />
                            </Grid>
                            <div className="tableBody">
                                {subscription.orderHistoryResult.map((order, i) => {
                                    const key = `_${i}`;
                                    return (
                                        <Grid key={key} container className="itemRow">
                                            <Grid item xs={3}>{order.orderNumber}</Grid>
                                            <Grid item xs={3}>{this.dateFormater(order.orderDate)}</Grid>
                                            <Grid item xs={3}>{this.dateFormater(order.deliveryDate)}</Grid>
                                            <Grid item xs={3}>
                                                <span role="presentation" className="link" onClick={() => this.generateViewDetailsURL(order.orderNumber, history)}>View Details</span>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid className="" item xs={12}>
                        <Grid container className="frequencyHead">
                            <Grid className="" item xs={2}>Frequency</Grid>
                            <Grid className="" item xs={2}>Duration</Grid>
                            <Grid className="" item xs={2}>Start Date</Grid>
                            <Grid className="" item xs={2}>End Date</Grid>
                            <Grid className="" item xs={2}>Next Order Date</Grid>
                            <Grid className="" item xs={2}>Status</Grid>
                        </Grid>
                        <Grid container>
                            <Grid className="" item xs={2}>{this.subscriptionInterval(subscription.interval)}</Grid>
                            <Grid className="" item xs={2}>{this.subscriptionDuration(subscription.duration)}</Grid>
                            <Grid className="" item xs={2}>{subscription.startDate}</Grid>
                            <Grid className="" item xs={2}>{subscription.endDate === 'Indefinite' ? (<span>-</span>) : subscription.endDate}</Grid>
                            <Grid className="" item xs={2}>{subscription.nextOrderDate ? subscription.nextOrderDate : '-'}</Grid>
                            <Grid className="" item xs={2}>{this.statusTemplate(classes, subscription.ruleId, subscription.subscriptionStatus)}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <SubscriptionCancelDialog open={cancelDialogOpen} onCancelClose={this.handleCancelDialogClose} onConfirmClose={this.handleCancelConfirmed} isDesktop />
            </>
        );
    }
}

DesktopSubscriptionDetail.defaultProps = {
    subscription: {},
    history: {},
};

DesktopSubscriptionDetail.propTypes = {
    classes: object.isRequired,
    subscription: shape({
        checkoutBrand: string,
        duration: number.isRequired,
        endDate: string.isRequired,
        interval: number.isRequired,
        nextOrderDate: string,
        orderDate: string.isRequired,
        orderHistoryResult: arrayOf(
            shape({
                deliveryDate: string,
                discountAmount: string,
                orderDate: string.isRequired,
                orderNumber: string.isRequired,
                productCode: string.isRequired,
                productName: string.isRequired,
                productPrice: string.isRequired,
                quantity: string.isRequired,
            }),
        ),
        orderNumber: string.isRequired,
        orderTime: string.isRequired,
        orderType: string.isRequired,
        price: string.isRequired,
        productId: string.isRequired,
        productImageCategory: string.isRequired,
        productImageThumbnail: string.isRequired,
        productName: string.isRequired,
        quantity: string,
        recipient: arrayOf(shape({
            city: string.isRequired,
            country: string.isRequired,
            firstName: string.isRequired,
            lastName: string.isRequired,
            state: string.isRequired,
            street1: string.isRequired,
            street2: string.isRequired,
            zipcode: string.isRequired,
        })),
        ruleId: string.isRequired,
        startDate: string.isRequired,
        subscriptionStatus: string.isRequired,
        totalAmount: string.isRequired,
    }),
    history: object,
    handleCancel: func.isRequired,
};

export default withRouter(withStyles(styles, { withTheme: true })(DesktopSubscriptionDetail));
